<template>
  <div>
    <Nav></Nav>
    <b-container fluid>
      <b-row>
        <b-col class="text-left">
          <h1>{{ actualCompra.name }}<p>COMPRA ID: {{ actualCompra.id }}</p>
          </h1>
        </b-col>
      </b-row>
      <b-row class="text-left">
        <b-col xl="6" md="12" xs="12">
          <b-button :disabled="lockButtons || !canEditItems || (actualCompraItems && actualCompraItems.length > 0)" @click="$bvModal.show('modal-loadList')"
            size="sm mr-3" variant="default" class="ml-2 mb-2">Cargar
            Lista de Compra</b-button>
          <b-button :disabled="lockButtons" @click="downloadExcel('xlsx')" size="sm mr-3" variant="default"
            class="ml-2 mb-2">Descargar Excel</b-button>
          <b-button :disabled="lockButtons" @click="downloadExcel('pdf')" size="sm mr-3" variant="default"
            class="ml-2 mb-2">Descargar PDF</b-button>
          <b-button :disabled="lockButtons || !canRecalculate" size="sm mr-3" @click="recalculatePO" variant="default" class="ml-2 mb-2">
            Recalcular
          </b-button>
          <b-button :disabled="lockButtons || !canRecalculate" size="sm mr-3" @click="recalculateTaxes" variant="info" class="ml-2 mb-2">
            Recalcular Impuestos
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualCompra.status != 'cancel'" @click="sendPO('send')"
            size="sm mr-3" variant="success" class="ml-2 mb-2">
            {{ actualCompra.status == "draft" ? "Enviar" : "Reenviar" }}
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualCompra.status == 'sent'" @click="sendPO('confirm')"
            size="sm mr-3" variant="success" class="ml-2 mb-2">
            Confirmar
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualCompra.status == 'confirmed'" @click="sendPO('purchase')"
            size="sm mr-3" variant="success" class="ml-2 mb-2">
            Realizar Compra
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualCompra.status == 'purchase'" @click="sendPO('assign')"
            size="sm mr-3" variant="success" class="ml-2 mb-2">
            Asignar
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualCompra.status == 'assigned'" @click="sendPO('done')"
            size="sm mr-3" variant="success" class="ml-2 mb-2">
            Terminar
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualCompra.status != 'cancel'" @click="sendPO('cancel')"
            size="sm mr-3" variant="danger" class="ml-2 mb-2">
            Cancelar
          </b-button>
          <b-button :disabled="lockButtons" v-show="actualCompra.status == 'cancel'" @click="sendPO('undocancel')"
            size="sm mr-3" variant="info" class="ml-2 mb-2">
            Deshacer Cancelacion
          </b-button>
          <b-button :disabled="lockButtons" @click="sendPO('revert')" size="sm mr-3" variant="warning"
            class="ml-2 mb-2">
            Revertir
          </b-button>
          <b-button :disabled="lockButtons" @click="populateUpdateForm(); $bvModal.show('modal-updatePO')" size="sm mr-3" variant="info"
            class="ml-2 mb-2">
            Editar
          </b-button>

        </b-col>
        <b-col xl="6" md="12" xs="12">
          <progress-steps :steps="processSteps" :currentStep="actualCompra.status"></progress-steps>
        </b-col>
      </b-row>
      <b-card class="my-2 p-1">
        <b-row>
          <b-col lg="6" md="12">
            <table class="table table-borderless text-left table-sm">
              <tbody>
                <tr>
                  <td><b>Sucursal:</b></td>
                  <td>{{ actualCompra.sucursal.nombre }}</td>
                </tr>
                <tr>
                  <td><b>Proveedor:</b></td>
                  <td>{{ actualCompra.provider.name }}</td>
                </tr>
                <tr>
                  <td><b>Status:</b></td>
                  <td><b-badge :variant="statusBadge(actualCompra.status).variant">{{
                    statusBadge(actualCompra.status).text }}</b-badge></td>
                </tr>
                <tr>
                  <td><b>Creado Por:</b></td>
                  <td>{{ actualCompra.user.name }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
          <b-col lg="6" md="12">
            <table class="table  table-borderless text-left table-sm">
              <tbody>
                <tr>
                  <td><b>Fecha de Creación:</b></td>
                  <td>{{ actualCompra.date_create }}</td>
                </tr>
                <tr>
                  <td><b>Fecha de entrega:</b></td>
                  <td>{{ actualCompra.date_planned }}</td>
                </tr>
                <tr>
                  <td><b>Fecha de Orden:</b></td>
                  <td>{{ actualCompra.date_order }}</td>
                </tr>
                <tr>
                  <td><b>Notas:</b></td>
                  <td>{{ actualCompra.notes }}</td>
                </tr>
                <tr>
                  <td><b>Referencia de Factura:</b></td>
                  <td>{{ actualCompra.invoice_rel }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <table class="table table-sm text-left table-responsive">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Producto</th>
                  <th>Cantidad</th>
                  <th>Recibido</th>
                  <th>Facturado</th>
                  <th>Unidad</th>
                  <th>Precio Unit.</th>
                  <th>Desc.</th>
                  <th>Subtotal</th>
                  <th>Impuestos</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in actualCompraItems" v-bind:key="item.id" @click="getCompraItem(item.id)">
                  <td>{{ item.id }}</td>
                  <td>{{ item.product.name }}</td>
                  <td>{{ item.product_quantity }}</td>
                  <td>{{ item.qty_received }}</td>
                  <td>{{ item.qty_invoiced }}</td>
                  <td>{{ item.product.unit }}</td>
                  <td>
                    <div class="d-flex align-items-center">
                      <span>${{ item.price_unit ? item.price_unit.toFixed(2) : '0.00' }}</span>
                      <b-badge
                        v-if="item.is_price_temporal"
                        variant="warning"
                        class="ml-2"
                        v-b-tooltip.hover
                        :title="getTemporalPriceTooltip(item)">
                        <b-icon icon="clock"></b-icon>
                        Auto
                      </b-badge>
                      <b-badge
                        v-if="item.original_price_unit && item.original_price_unit !== item.price_unit"
                        variant="info"
                        class="ml-1"
                        v-b-tooltip.hover
                        :title="`Precio original: ${item.original_price_unit}`">
                        <b-icon icon="arrow-up"></b-icon>
                      </b-badge>
                    </div>
                  </td>
                  <td>
                    <span v-if="item.discount && item.discount > 0" class="text-danger">
                      {{ item.discount.toFixed(0) }}%
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td>${{ item.price_subtotal ? item.price_subtotal.toFixed(2) : '0.00' }}</td>
                  <td>
                    <div class="d-flex flex-column">
                      <small class="text-muted">${{ (item.price_tax || 0).toFixed(2) }}</small>
                      <b-button size="sm" variant="link" class="p-0" @click="getCompraItem(item.id)">
                        <small>
                          <b-icon icon="gear"></b-icon>
                          {{ canEditItems ? 'Gestionar' : 'Ver detalles' }}
                        </small>
                      </b-button>
                    </div>
                  </td>
                  <td><b>${{ item.price_total ? item.price_total.toFixed(2) : '0.00' }}</b></td>
                  <td>
                    <b-icon-pencil-fill v-if="canEditItems" @click="getCompraItem(item.id)" variant="success"
                      class="mx-2" style="cursor: pointer;"></b-icon-pencil-fill>
                    <b-icon-pencil-fill v-else variant="secondary" class="mx-2" style="cursor: not-allowed;" title="No se puede editar en este estado"></b-icon-pencil-fill>
                    <b-icon-trash-fill v-if="canEditItems" @click="deleteCompraItems(item.id)" variant="danger"
                      class="mx-2" style="cursor: pointer;"></b-icon-trash-fill>
                    <b-icon-trash-fill v-else variant="secondary" class="mx-2" style="cursor: not-allowed;" title="No se puede eliminar en este estado"></b-icon-trash-fill>
                    <!-- <b-button @click="getCompraItem(item.id)" size="sm" variant="success" class="mr-1 mb-1">
                      <b-icon-pencil-fill></b-icon-pencil-fill>
                    </b-button>
                    <b-button @click="deleteCompraItems(item.id)" size="sm" variant="danger" class="mr-1 mb-1">
                      <b-icon-trash-fill></b-icon-trash-fill>
                    </b-button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="text-left my-2">
          <b-col>
            <b-button v-if="canEditItems" @click="cleanSelectedSupply(); $bvModal.show('modal-newProduct')" v-shortkey="['ctrl', 'n']"
              @shortkey="canEditItems ? (cleanSelectedSupply(), $bvModal.show('modal-newProduct')) : null" size="sm mr-3">Agregar
              Producto</b-button>
            <b-button v-else disabled size="sm mr-3" title="No se pueden agregar productos en este estado">Agregar
              Producto</b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="d-flex flex-row-reverse">
              <div class="flex-grow-1 flex-sm-grow-0">
                <table class="table table-borderless text-left table-sm">
                  <tbody>
                    <tr v-if="actualCompra.amount_before_discount && actualCompra.amount_before_discount > 0">
                      <td><b>Subtotal Original:</b></td>
                      <td>${{ actualCompra.amount_before_discount ? actualCompra.amount_before_discount.toFixed(2) : '0.00' }}</td>
                    </tr>
                    <tr v-if="actualCompra.total_discount_amount && actualCompra.total_discount_amount > 0">
                      <td><b>Descuento Total:</b></td>
                      <td class="text-danger">-${{ actualCompra.total_discount_amount ? actualCompra.total_discount_amount.toFixed(2) : '0.00' }}</td>
                    </tr>
                    <tr>
                      <td><b>Subtotal:</b></td>
                      <td>${{ actualCompra.amount_untaxed ? actualCompra.amount_untaxed.toFixed(2) : '0.00' }}</td>
                    </tr>
                    <tr>
                      <td><b>Impuestos:</b></td>
                      <td>${{ actualCompra.amount_tax ? actualCompra.amount_tax.toFixed(2) : '0.00' }}</td>
                    </tr>
                    <tr>
                      <td><b>Total:</b></td>
                      <td><b>${{ actualCompra.amount_total ? actualCompra.amount_total.toFixed(2) : '0.00' }}</b></td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>

          </b-col>
        </b-row>
      </b-card>
    </b-container>
    <b-modal id="modal-newProduct" @shown="focusSupplySelect" @close="emptyNewItem" :hide-footer="true" size="xl"
      :title="newItem.id ? (canEditItems ? 'Editar Producto' : 'Ver Detalles del Producto') : 'Agregar Producto'">
      <b-row>
        <b-col lg="12" cols="12">
          <b-form-group label="Producto" description="Selecciona el producto a agregar">
            <vu-select @input="selectedProduct" ref="supplySelect" v-model.number="newItem.supply_id"
              :options="supplies" :reduce="(x) => x.id" label="name"></vu-select>
          </b-form-group>
        </b-col>
        <b-col cols="10" md="11" lg="5">
          <b-form-group label="Cantidad" description="Cantidad a Solicitar">
            <b-input-group>
              <b-form-input ref="supplyQty" v-on:keydown.enter="qtyDone" @input="recalculateNewItem" :min="0"
                v-model.number="newItem.product_quantity" type="number" :disabled="!canEditItemPricesQty" required></b-form-input>
              <VueInputCalculator :is-history-logs="false" @input="recalculateNewItem" :enable-keyboard="true" v-model="newItem.product_quantity">
                <b-input-group-append>
                  <b-button variant="info">
                    <b-icon icon="calculator"></b-icon>
                  </b-button>
                </b-input-group-append>
              </VueInputCalculator>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="2" md="1" lg="1">
          <b-form-group label="UD">
            <h2><b-badge variant="success">{{ selectedSupply.unit }}</b-badge></h2>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" lg="4">
          <b-form-group label="Precio Unitario" description="Precio por unidad">
            <b-input-group>
              <b-form-input ref="supplyPrice" v-on:keydown.enter="focusDiscountInput" @input="recalculateNewItem" :min="0"
              v-model.number="newItem.price_unit" type="number" :disabled="!canEditItemPricesQty" required></b-form-input>
              <VueInputCalculator :is-history-logs="false" @input="recalculateNewItem" :enable-keyboard="true" v-model="newItem.price_unit">
                <b-input-group-append>
                  <b-button variant="info">
                    <b-icon icon="calculator"></b-icon>
                  </b-button>
                </b-input-group-append>
              </VueInputCalculator>
            </b-input-group>

            <!-- Last Buy Price Info -->
            <div v-if="selectedSupplyLastBuyPrice" class="mt-2">
              <b-alert show variant="info" class="py-2">
                <small>
                  <b-icon icon="info-circle"></b-icon>
                  <strong>Último precio de compra:</strong> ${{ selectedSupplyLastBuyPrice.last_buy_price }}
                  <span v-if="selectedSupplyLastBuyPrice.last_buy_date">
                    ({{ formatDateShort(selectedSupplyLastBuyPrice.last_buy_date) }})
                  </span>
                  <b-button
                    size="sm"
                    variant="outline-primary"
                    class="ml-2"
                    @click="useLastBuyPrice">
                    Usar este precio
                  </b-button>
                </small>
              </b-alert>
            </div>

            <!-- Temporal Price Warning -->
            <div v-if="newItem.is_price_temporal" class="mt-2">
              <b-alert show variant="warning" class="py-2">
                <small>
                  <b-icon icon="clock"></b-icon>
                  <strong>Precio temporal:</strong> Este precio fue auto-llenado desde el último precio de compra.
                  <span v-if="newItem.original_price_unit">
                    (Precio original: ${{ newItem.original_price_unit }})
                  </span>
                </small>
              </b-alert>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6" lg="2">
          <b-form-group label="Descuento %" description="Porcentaje de descuento">
            <b-input-group>
              <b-form-input
                ref="discountInput"
                v-on:keydown.enter="createNewItem"
                @input="recalculateNewItem"
                :min="0"
                :max="100"
                v-model.number="newItem.discount"
                type="number"
                :disabled="!canEditItemPricesQty">
              </b-form-input>
              <b-input-group-append>
                <b-button variant="outline-secondary" disabled>
                  %
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="d-flex justify-content-between">
            <div>
              <span v-if="newItem.discount > 0">
                Precio Original: ${{ (newItem.price_unit * newItem.product_quantity).toFixed(2) }}<br>
                Descuento: <span class="text-danger">-${{ ((newItem.price_unit * newItem.product_quantity) * (newItem.discount/100)).toFixed(2) }}</span><br>
              </span>
              Subtotal: <b>${{ newItem.price_subtotal ? newItem.price_subtotal.toFixed(2) : '0.00' }}</b><br>
              Impuestos: ${{ newItem.price_tax ? newItem.price_tax.toFixed(2) : '0.00' }}<br>
              Total: <b>${{ newItem.price_total ? newItem.price_total.toFixed(2) : '0.00' }}</b>
            </div>
          </div>
        </b-col>
      </b-row>

      <!-- Tax Management Section (only show when editing existing item) -->
      <b-row v-if="newItem.id > 0" class="mt-3">
        <b-col>
          <b-card>
            <template #header>
              <h6 class="mb-0">
                <b-icon icon="calculator"></b-icon>
                Gestión de Impuestos - {{ selectedSupply.name || 'Artículo' }}
              </h6>
            </template>

            <purchase-order-item-tax-manager
              :purchase-order-id="actualCompra.id"
              :item-id="newItem.id"
              :base-amount="newItem.price_subtotal || 0"
              :readonly="!canManageTaxes"
              @success="handleTaxSuccess"
              @error="handleTaxError"
              @tax-updated="handleTaxUpdated"
            />
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="my-3">
          <b-button v-if="canEditItems" class="mr-3" @click="createNewItem" variant="success">
            {{ newItem.id ? 'Actualizar' : 'Guardar' }}
          </b-button>
          <b-button class="mr-3" @click="$bvModal.hide('modal-newProduct'); emptyNewItem();"
            :variant="canEditItems ? 'danger' : 'secondary'">
            {{ canEditItems ? 'Cancelar' : 'Cerrar' }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-loadList" :hide-footer="true" size="xl" title="Cargar lista de compras">
      <b-row>
        <b-col lg="12" cols="12">
          <b-form-group label="Lista de Compras" description="Selecciona la lista de compras que quieres cargar">
            <vu-select v-model.number="selectedShoppingList" :options="shoppingLists" :reduce="(x) => x.id" label="name"
              @input="getShoppingListItems"></vu-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <ul>
            <li v-for="item in shoppingListItemList" v-bind:key="item.id">{{ item.name }}</li>
          </ul>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button @click="addShoppinglistitemsToPO" variant="success" class="mr-1 mb-1">Agregar a mi orden</b-button>
          <b-button variant="danger" class="mr-1 mb-1">Cancelar</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-sendMessage" @shown="initQuillEditor" @hidden="cleanupQuillEditor" :hide-footer="true" size="xl" title="Enviar Orden de compra">
      <b-alert :show="!isValidEmail(actualCompra.provider.email)" variant="danger" dismissible>
        El email del proveedor no es válido {{actualCompra.provider.email}}
      </b-alert>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Destinatario" description="Destinatario del mensaje">
            <b-form-input disabled v-model="actualCompra.provider.email" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Asunto" description="Asunto del mensaje">
            <b-form-input v-model="messageForm.subject" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Mensaje" description="Contenido del mensaje">
            <div ref="quillEditor" style="height: 300px;"></div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="my-3">
          <b-button class="mr-3" @click="sendHtmlMessage" variant="success">Enviar</b-button>
          <b-button class="mr-3" @click="$bvModal.hide('modal-sendMessage'); resetMessageForm();"
            variant="danger">Cancelar</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-updatePO" :hide-footer="true" size="xl" title="Editar Orden de Compra">
      <b-alert v-if="isRestrictedStatus" show variant="warning">
        Esta orden está en estado <strong>{{ statusBadge(actualCompra.status).text }}</strong>. 
        Solo se pueden editar las notas y referencia de factura.
      </b-alert>
      <b-row>
        <b-col lg="6" md="12">
          <b-form-group label="Proveedor" description="Selecciona el proveedor">
            <vu-select v-model.number="updateForm.provider_id" :options="providers" :reduce="(x) => x.id" 
              label="name" :disabled="isRestrictedStatus"></vu-select>
          </b-form-group>
        </b-col>
        <b-col lg="6" md="12">
          <b-form-group label="Fecha de Entrega" description="Fecha planificada de entrega">
            <b-form-input v-model="updateForm.date_planned" type="date" :disabled="isRestrictedStatus" required></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="6" md="12">
          <b-form-group label="Nombre de la Orden" description="Nombre identificador de la orden (mínimo 3 caracteres)">
            <b-form-input v-model="updateForm.name" type="text" :disabled="isRestrictedStatus" required minlength="3"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Notas" description="Notas adicionales">
            <b-form-textarea v-model="updateForm.notes" rows="3"></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Referencia de Factura" description="Referencia de factura relacionada">
            <b-form-input v-model="updateForm.invoice_rel" type="text"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="my-3">
          <b-button class="mr-3" @click="updatePurchaseOrder" variant="success">Actualizar</b-button>
          <b-button class="mr-3" @click="$bvModal.hide('modal-updatePO'); resetUpdateForm();"
            variant="danger">Cancelar</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <loading-modal ref="loadingModal" mensaje="Procesando"
      descripcion="Por favor espere mientras se completa la operación."></loading-modal>
  </div>
</template>
<style>
.table-borderless>tbody>tr>td,
.table-borderless>tbody>tr>th,
.table-borderless>tfoot>tr>td,
.table-borderless>tfoot>tr>th,
.table-borderless>thead>tr>td,
.table-borderless>thead>tr>th {
  border: none;

}
</style>
<script>
import axios from "axios";
import Nav from "../components/Nav.vue";
import ProgressSteps from "../components/ProgressSteps.vue";
import loadingModal from "../components/LoadingModal.vue";
import VueInputCalculator from "vue-input-calculator";
import PurchaseOrderItemTaxManager from "../components/PurchaseOrderItemTaxManager.vue";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import QuillBetterTable from "quill-better-table";
import "quill-better-table/dist/quill-better-table.css";

Quill.register({
  'modules/better-table': QuillBetterTable
});

export default {
  name: "Compra",
  components: {
    Nav, ProgressSteps, loadingModal, VueInputCalculator, PurchaseOrderItemTaxManager
  },

  data() {
    return {
      lockButtons: false,
      quillEditor: null,
      messageForm: {
        subject: "",
        content: ""
      },
      processSteps: [
        { name: "draft", label: "Borrador" },
        { name: "sent", label: "Enviado" },
        { name: "confirmed", label: "Confirmado" },
        { name: "purchase", label: "En Compra" },
        { name: "assigned", label: "Asignado" },
        { name: "done", label: "Hecho" },
        { name: "cancel", label: "Cancelado" },
      ],
      addingShoppingList: false,
      selectedShoppingList: null,
      shoppingListItems: [],
      shoppingListItemList: [],
      shoppingLists: [],
      supplies: [],
      providers: [],
      updateForm: {
        provider_id: null,
        date_planned: "",
        date_order: "",
        name: "",
        notes: "",
        invoice_rel: ""
      },
      actualCompra: {
        id: null,
        company_id: null,
        sucursal_id: null,
        provider_id: null,
        user_id: null,
        name: "",
        status: "",
        amount_untaxed: null,
        amount_tax: null,
        amount_total: null,
        total_discount_amount: null,
        amount_before_discount: null,
        date_create: null,
        date_order: null,
        date_planned: null,
        date_approve: null,
        sucursal: {
          nombre: null
        },
        provider: {
          name: null
        },
        user: {
          name: null
        }
      },
      actualCompraItems: [],
      selectedSupply: {
        unit: null
      },
      newItem: {
        id: null,
        purchase_order_id: null,
        supply_id: null,
        name: "",
        discount: 0,
        price_unit: 0,
        price_subtotal: 0,
        price_tax: 0,
        price_total: 0,
        product_quantity: 1,
        qty_invoiced: 0,
        qty_received: 0,
        qty_to_invoice: 0,
        original_price_unit: null,
        is_price_temporal: false,
      },
      selectedSupplyLastBuyPrice: null
    };
  },

  computed: {
    isRestrictedStatus() {
      const restrictedStatuses = ['purchase', 'assigned', 'done', 'cancel']
      return restrictedStatuses.includes(this.actualCompra.status)
    },
    canEditItems() {
      // Items can only be edited/added/deleted in draft, sent, and confirmed states
      const editableStatuses = ['draft', 'sent', 'confirmed']
      return editableStatuses.includes(this.actualCompra.status)
    },
    canEditItemPricesQty() {
      // Prices and quantities can only be edited in draft and sent states
      const editableStatuses = ['draft', 'sent']
      return editableStatuses.includes(this.actualCompra.status)
    },
    canManageTaxes() {
      // Taxes can only be managed in draft, sent, and confirmed states
      const editableStatuses = ['draft', 'sent', 'confirmed','purchase','assigned','done']
      return editableStatuses.includes(this.actualCompra.status)
    },
    canRecalculate() {
      // Recalculation can only be done in draft, sent, and confirmed states
      const editableStatuses = ['draft', 'sent', 'confirmed','purchase','assigned','done']
      return editableStatuses.includes(this.actualCompra.status)
    }
  },
  watch: {},
  mounted() {
    if (this.$route.params.id > 0) {
      this.actualCompra.id = this.$route.params.id;
      this.getCompra()
      this.getCompraItems()
      this.getSupplies()
      this.emptyNewItem()
      this.getShoppingLists()
      this.getProviders()
    }
    this.initQuillEditor();
  },
  created() {

  },
  methods: {
    statusBadge(status) {
      let rtn = { variant: "", text: status }
      switch (status) {
        case "draft":
          rtn.variant = "warning"
          rtn.text = "Borrador"
          break;
        case "sent":
          rtn.variant = "warning"
          rtn.text = "Enviado"
          break;
        case "confirmed":
          rtn.variant = "primary"
          rtn.text = "Confirmado"
          break;
        case "assigned":
          rtn.variant = "primary"
          rtn.text = "Asignado"
          break;
        case "done":
          rtn.variant = "success"
          rtn.text = "Hecho"
          break;

        case "canceled":
          rtn.variant = "danger"
          rtn.text = "Cancelado"
          break;
      }
      return rtn
    },
    focusSupplySelect() {
      if (this.newItem.supply_id == null) {
        this.$refs.supplySelect.$refs.search.focus()
      } else {
        this.$refs.supplyQty.$el.focus()
      }
    },
    cleanSelectedSupply() {
      this.selectedSupply = {
        unit: null
      }
      this.selectedSupplyLastBuyPrice = null
    },

    // Last Buy Price methods
    async fetchLastBuyPrice(supplyId) {
      try {
        const response = await axios.get(`/supplies/${supplyId}/last-buy-price`)
        this.selectedSupplyLastBuyPrice = response.data
      } catch (error) {
        console.warn('No last buy price data available:', error)
        this.selectedSupplyLastBuyPrice = null
      }
    },

    useLastBuyPrice() {
      if (this.selectedSupplyLastBuyPrice && this.selectedSupplyLastBuyPrice.last_buy_price) {
        this.newItem.original_price_unit = this.newItem.price_unit
        this.newItem.price_unit = this.selectedSupplyLastBuyPrice.last_buy_price
        this.newItem.is_price_temporal = true
        this.recalculateNewItem()
      }
    },

    getTemporalPriceTooltip(item) {
      let tooltip = 'Precio auto-llenado desde último precio de compra'
      if (item.original_price_unit) {
        tooltip += ` (Original: $${item.original_price_unit})`
      }
      return tooltip
    },

    formatDateShort(dateString) {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      return date.toLocaleDateString('es-MX', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      })
    },
    async selectedProduct() {
      let that = this
      this.cleanSelectedSupply()
      this.selectedSupply = this.supplies.find(x => x.id == this.newItem.supply_id)

      // Fetch last buy price for the selected supply
      if (this.newItem.supply_id) {
        await this.fetchLastBuyPrice(this.newItem.supply_id)
      }

      setTimeout(function () {
        console.log("focusing")
        that.$refs.supplyQty.$el.focus()
      }, 100)
    },
    qtyDone() {
      let that = this
      console.log("qtyDone")
      setTimeout(function () {
        that.$refs.supplyPrice.$el.focus()
      }, 100)
    },
    focusDiscountInput() {
      let that = this
      setTimeout(function () {
        if (that.$refs.discountInput) {
          that.$refs.discountInput.$el.focus()
        }
      }, 100)
    },
    sendPO(action) {
      if (action === 'send') {
        this.messageForm.subject = `Orden de Compra ${this.actualCompra.name} - ${this.actualCompra.provider.name}`;
        this.$bvModal.show('modal-sendMessage');
        return;
      }
      
      this.$bvModal.msgBoxConfirm('Seguro que quieres cambiar de status', {
        title: 'Confirmacion',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'Si',
        cancelTitle: "No",
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
        .then(value => {
          if (value) {
            this.lockButtons = true
            this.$refs.loadingModal.mostrar()
            let that = this
            axios.post('/purchaseorder/' + this.actualCompra.id + '/' + action)
              .then(function () {
                that.getCompra()
                that.getCompraItems()
                that.makeToast("success", "Enviado", "exito")
                that.lockButtons = false
                that.$refs.loadingModal.ocultar()
              })
              .catch(function (error) {
                that.makeToast("danger", "Error", error.response.data);
                that.lockButtons = false
                that.$refs.loadingModal.ocultar()
              });
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    downloadExcel(format) {
      this.$refs.loadingModal.mostrar()
      let that = this
      axios.get('/purchaseorder/' + this.actualCompra.id + '?format=' + format, {
        "responseType": "blob",
        headers: {
          'Accept': '*/*',
        }
      })
        .then(function (response) {
          console.log(response.headers)
          console.log(response)
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          console.log(response.headers)
          let filename = 'downloaded_file.' + format; // Fallback filename in case the header is missing
          if (contentDisposition && contentDisposition.includes('filename')) {
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, ''); // Remove any surrounding quotes
            }
          }
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          that.$refs.loadingModal.ocultar()
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => that.makeToast("danger", "Error", error.response.data));

    },
    recalculateNewItem() {
      if (this.newItem.product_quantity < 0) {
        this.newItem.product_quantity = 1
      }
      if (this.newItem.price_unit < 0) {
        this.newItem.price_unit = 1
      }
      if (this.newItem.discount < 0) {
        this.newItem.discount = 0
      }
      if (this.newItem.discount > 100) {
        this.newItem.discount = 100
      }

      // Calculate subtotal with discount
      const grossAmount = this.newItem.product_quantity * this.newItem.price_unit
      const discountAmount = this.newItem.discount > 0 ? grossAmount * (this.newItem.discount / 100) : 0
      this.newItem.price_subtotal = grossAmount - discountAmount
      this.newItem.price_total = this.newItem.price_subtotal + (this.newItem.price_tax || 0)
    },
    emptyNewItem() {
      this.newItem = {
        id: null,
        purchase_order_id: this.actualCompra.id,
        supply_id: null,
        name: "",
        discount: 0,
        price_unit: 0,
        price_subtotal: 0,
        price_tax: 0,
        price_total: 0,
        product_quantity: 1,
        qty_invoiced: 0,
        qty_received: 0,
        qty_to_invoice: 0,
        original_price_unit: null,
        is_price_temporal: false,
      }
    },
    getSupplies() {
      let that = this
      axios.get("/supplies")
        .then(function (res) {
          that.supplies = res.data.map(function (el) {
            el.name = el.code + " - " + el.name
            return el
          })
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    getShoppingLists() {
      let that = this
      axios.get("/shoppinglists")
        .then(function (res) {
          that.shoppingLists = res.data
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    addShoppinglistitemsToPO() {
      if (this.addingShoppingList) {
        this.makeToast("danger", "Error", "La lista esta siendo cargada, espera un momento")
        return
      }
      this.addingShoppingList = true
      this.$refs.loadingModal.mostrar()

      let that = this
      axios.post("/purchaseorder/" + this.actualCompra.id + "/items/addShoppingList/" + this.selectedShoppingList)
        .then(function (res) {
          console.log(res)
          that.$bvModal.hide("modal-loadList")
          that.emptyNewItem()
          that.getCompraItems()
          that.addingShoppingList = false
          that.$refs.loadingModal.ocultar()
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
          that.addingShoppingList = false
          that.$refs.loadingModal.ocultar()
        })
    },
    getShoppingListItems() {
      let that = this
      axios.get("/shoppinglist/" + this.selectedShoppingList + "/items")
        .then(function (res) {
          that.shoppingListItems = res.data
          let av = that.shoppingListItems.map(function (item) {
            return that.supplies.find((e) => e.id == item.supply_id)
          })
          that.shoppingListItemList = av
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    getCompra() {
      let that = this
      return axios.get("/purchaseorder/" + this.actualCompra.id)
        .then(function (res) {
          that.actualCompra = res.data
          return res.data
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
          throw err
        })
    },
    recalculatePO() {
      if (!this.canRecalculate) {
        this.makeToast("danger", "Error", "No se puede recalcular en el estado actual")
        return
      }
      
      this.$refs.loadingModal.mostrar()
      let that = this
      axios.get("/purchaseorder/" + this.actualCompra.id + "/recalculate")
        .then(function () {
          that.getCompra()
          that.getCompraItems()
          that.$refs.loadingModal.ocultar()
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
          that.$refs.loadingModal.ocultar()
        })
    },
    getCompraItems(showLoading = true) {
      if (showLoading) {
        this.$refs.loadingModal.mostrar()
      }

      let that = this
      return axios.get("/purchaseorder/" + this.actualCompra.id + "/items")
        .then(function (res) {
          if (showLoading) {
            that.$refs.loadingModal.ocultar()
          }
          that.actualCompraItems = res.data || []
          return res.data || []
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
          if (showLoading) {
            that.$refs.loadingModal.ocultar()
          }
          throw err
        })
    },
    deleteCompraItems(id) {
      if (!this.canEditItems) {
        this.makeToast("danger", "Error", "No se pueden eliminar productos en el estado actual")
        return
      }
      
      this.$refs.loadingModal.mostrar()
      let that = this
      axios.delete("/purchaseorder/" + this.actualCompra.id + "/item/" + id)
        .then(function () {
          that.getCompraItems()
          that.$refs.loadingModal.ocultar()
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
          that.$refs.loadingModal.ocultar()
        })
    },
    getSucursal() {
      let that = this;
      axios
        .get("/restaurant/id")
        .then(function (response) {
          that.actualSucursal = response.data;
          that.getCompras()
        })
        .catch(function (err) {
          console.log(err);
          that.makeToast("danger", "Error", err.response.data);
        });
    },
    getCompraItem(id) {
      let that = this
      axios.get("/purchaseorder/" + this.actualCompra.id + "/item/" + id, this.newItem)
        .then(function (res) {
          that.newItem = res.data
          that.cleanSelectedSupply()
          that.selectedSupply = that.supplies.find(x => x.id == that.newItem.supply_id)
          that.$bvModal.show('modal-newProduct')
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    createNewItem() {
      if (!this.canEditItems) {
        this.makeToast("danger", "Error", "No se pueden crear/editar productos en el estado actual")
        return
      }
      
      this.$refs.loadingModal.mostrar()
      let that = this
      this.newItem.purchase_order_id = parseInt(this.actualCompra.id)
      let fo_it = this.supplies.find((e) => e.id == this.newItem.supply_id)
      this.newItem.name = fo_it.name
      if (this.newItem.id == null) {
        let elm = this.newItem
        delete elm.id
        axios.post("/purchaseorder/" + this.actualCompra.id + "/item", elm)
          .then(async function (res) {
            if (res.data.id > 0) {
              try {
                // Call recalculate without showing its own loading modal
                await axios.get("/purchaseorder/" + that.actualCompra.id + "/recalculate")
                await that.getCompra()
                await that.getCompraItems(false)
                that.emptyNewItem()
                that.$bvModal.hide("modal-newProduct")
              } catch (recalcError) {
                console.error("Error during recalculation:", recalcError)
                that.makeToast("warning", "Advertencia", "El item se guardó pero hubo un error en el recálculo")
              }
            }
            that.$refs.loadingModal.ocultar()
          }).catch(function (err) {
            that.makeToast("danger", "Error", err.response.data)
            that.$refs.loadingModal.ocultar()
          })
      } else {
        axios.put("/purchaseorder/" + this.actualCompra.id + "/item/" + this.newItem.id, this.newItem)
          .then(async function (res) {
            if (res.data.id > 0) {
              try {
                // Call recalculate without showing its own loading modal
                await axios.get("/purchaseorder/" + that.actualCompra.id + "/recalculate")
                await that.getCompra()
                await that.getCompraItems(false)
                that.emptyNewItem()
                that.$bvModal.hide("modal-newProduct")
              } catch (recalcError) {
                console.error("Error during recalculation:", recalcError)
                that.makeToast("warning", "Advertencia", "El item se actualizó pero hubo un error en el recálculo")
              }
            }
            that.$refs.loadingModal.ocultar()
          }).catch(function (err) {
            that.makeToast("danger", "Error", err.response.data)
            that.$refs.loadingModal.ocultar()
          })
      }

    },
    initQuillEditor() {
      this.$nextTick(() => {
        if (this.$refs.quillEditor) {
          // Clean up existing editor if it exists
          if (this.quillEditor) {
            this.quillEditor = null;
          }
          
          // Clear the container
          this.$refs.quillEditor.innerHTML = '';
          
          // Create new editor instance
          this.quillEditor = new Quill(this.$refs.quillEditor, {
            theme: "snow",
            modules: {
              toolbar: [
                [{ header: [1, 2, 3, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ color: [] }, { background: [] }],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["link"],
                ["clean"]
              ],
              'better-table': {
                operationMenu: {
                  items: {
                    unmergeCells: {
                      text: "Separar celdas"
                    },
                    insertColumnRight: {
                      text: "Insertar columna derecha"
                    },
                    insertColumnLeft: {
                      text: "Insertar columna izquierda"
                    },
                    insertRowUp: {
                      text: "Insertar fila arriba"
                    },
                    insertRowDown: {
                      text: "Insertar fila abajo"
                    },
                    mergeCells: {
                      text: "Combinar celdas"
                    },
                    deleteColumn: {
                      text: "Eliminar columna"
                    },
                    deleteRow: {
                      text: "Eliminar fila"
                    },
                    deleteTable: {
                      text: "Eliminar tabla"
                    }
                  }
                }
              }
            }
          });
          
          // Add table button manually
          const toolbar = this.quillEditor.getModule('toolbar');
          const tableBtn = document.createElement('button');
          tableBtn.innerHTML = '📋';
          tableBtn.title = 'Insertar Tabla';
          tableBtn.onclick = () => {
            const tableModule = this.quillEditor.getModule('better-table');
            tableModule.insertTable(3, 3);
          };
          toolbar.container.appendChild(tableBtn);
          
          // Add clipboard image paste support
          this.quillEditor.root.addEventListener('paste', (e) => {
            const clipboardData = e.clipboardData || window.clipboardData;
            if (clipboardData && clipboardData.items) {
              const items = clipboardData.items;
              
              for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.type.indexOf('image') !== -1) {
                  e.preventDefault();
                  const blob = item.getAsFile();
                  this.handleClipboardImage(blob);
                  break;
                }
              }
            }
          });
        }
      });
    },
    getContents() {
      if (this.quillEditor) {
        return this.quillEditor.root.innerHTML;
      }
      return "";
    },
    cleanupQuillEditor() {
      if (this.quillEditor) {
        this.quillEditor = null;
      }
    },
    resetMessageForm() {
      this.messageForm = {
        subject: "",
        content: ""
      };
      if (this.quillEditor) {
        this.quillEditor.setContents([]);
      }
    },
    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },
    sendHtmlMessage() {
      if (!this.messageForm.subject) {
        this.makeToast("danger", "Error", "Por favor completa el asunto");
        return;
      }
      
      this.messageForm.content = this.getContents();
      
      this.$refs.loadingModal.mostrar();
      let that = this;
      
      const messageData = {
        subject: this.messageForm.subject,
        body: this.messageForm.content
      };
      
      axios.post('/purchaseorder/' + this.actualCompra.id + '/send', messageData)
        .then(function () {
          that.getCompra()
          that.getCompraItems()
          that.makeToast("success", "Enviado", "Orden enviada con mensaje HTML");
          that.$bvModal.hide('modal-sendMessage');
          that.resetMessageForm();
          that.$refs.loadingModal.ocultar();
        })
        .catch(function (error) {
          that.makeToast("danger", "Error", error.response.data);
          that.$refs.loadingModal.ocultar();
        });
    },
    getProviders() {
      let that = this
      axios.get("/providers")
        .then(function (res) {
          that.providers = res.data
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
        })
    },
    populateUpdateForm() {
      this.updateForm.provider_id = this.actualCompra.provider_id || this.actualCompra.provider?.id
      this.updateForm.date_planned = this.actualCompra.date_planned
      this.updateForm.date_order = this.actualCompra.date_order
      this.updateForm.name = this.actualCompra.name
      this.updateForm.notes = this.actualCompra.notes || ""
      this.updateForm.invoice_rel = this.actualCompra.invoice_rel || ""
    },
    resetUpdateForm() {
      this.updateForm = {
        provider_id: null,
        date_planned: "",
        date_order: "",
        name: "",
        notes: "",
        invoice_rel: ""
      }
    },
    updatePurchaseOrder() {
      // Validate name length for non-restricted statuses
      const restrictedStatuses = ['purchase', 'assigned', 'done', 'cancel']
      const isRestrictedStatus = restrictedStatuses.includes(this.actualCompra.status)

      if (!isRestrictedStatus) {
        if (!this.updateForm.name || this.updateForm.name.trim().length < 3) {
          this.makeToast("danger", "Error", "El nombre debe tener al menos 3 caracteres")
          return
        }
      }

      this.$refs.loadingModal.mostrar()
      let that = this

      let updateData
      
      if (isRestrictedStatus) {
        // For restricted statuses, only send notes and invoice_rel
        updateData = {
          notes: this.updateForm.notes,
          invoice_rel: this.updateForm.invoice_rel
        }
      } else {
        // For editable statuses (draft, sent, confirmed), send full update
        updateData = {
          id: this.actualCompra.id,
          company_id: this.actualCompra.company_id,
          sucursal_id: this.actualCompra.sucursal_id,
          user_id: this.actualCompra.user_id,
          status: this.actualCompra.status,
          date_create: this.actualCompra.date_create,
          provider_id: this.updateForm.provider_id,
          date_planned: this.updateForm.date_planned,
          date_order: this.actualCompra.date_order,
          name: this.updateForm.name,
          notes: this.updateForm.notes,
          invoice_rel: this.updateForm.invoice_rel,
          amount_untaxed: this.actualCompra.amount_untaxed,
          amount_tax: this.actualCompra.amount_tax,
          amount_total: this.actualCompra.amount_total,
          total_discount_amount: this.actualCompra.total_discount_amount,
          amount_before_discount: this.actualCompra.amount_before_discount
        }
      }
      
      axios.put("/purchaseorder/" + this.actualCompra.id, updateData)
        .then(function () {
          that.getCompra()
          that.makeToast("success", "Actualizado", "Orden de compra actualizada exitosamente")
          that.$bvModal.hide("modal-updatePO")
          that.resetUpdateForm()
          that.$refs.loadingModal.ocultar()
        }).catch(function (err) {
          that.makeToast("danger", "Error", err.response.data)
          that.$refs.loadingModal.ocultar()
        })
    },
    handleClipboardImage() {
      // Block image pasting with clear message
      this.$bvToast.toast("Imágenes no permitidas", {
          title: "Imágenes no permitidas",
          variant: "warning",
          solid: true,
          appendToast: true,
        });
    },
    
    // Tax management methods
    recalculateTaxes() {
      if (!this.canRecalculate) {
        this.makeToast("danger", "Error", "No se pueden recalcular impuestos en el estado actual")
        return
      }
      
      this.$refs.loadingModal.mostrar();
      let that = this;
      axios
        .post(`/purchase-orders/${this.actualCompra.id}/recalculate-taxes`)
        .then(function () {
          that.makeToast("success", "Éxito", "Impuestos recalculados exitosamente");
          that.getCompra();
          that.getCompraItems();
          that.$refs.loadingModal.ocultar();
        })
        .catch(function (err) {
          that.makeToast("danger", "Error", err.response?.data || "Error al recalcular impuestos");
          that.$refs.loadingModal.ocultar();
        });
    },

    // Method to refresh the current edit item data with updated tax amounts
    refreshEditItemData() {
      if (!this.newItem.id) return;

      let that = this;
      axios.get("/purchaseorder/" + this.actualCompra.id + "/item/" + this.newItem.id)
        .then(function (res) {
          // Update only the tax-related fields to preserve user changes
          that.newItem.price_tax = res.data.price_tax;
          that.newItem.price_total = res.data.price_total;
          that.recalculateNewItem(); // Recalculate to ensure consistency
        }).catch(function (err) {
          console.error('Error refreshing edit item data:', err);
        });
    },

    // Event handlers for PurchaseOrderItemTaxManager component
    handleTaxSuccess(message) {
      this.makeToast('success', 'Éxito', message);
    },

    handleTaxError(message) {
      this.makeToast('danger', 'Error', message);
    },

    handleTaxUpdated() {
      // Refresh the purchase order data to show updated totals
      this.getCompra();
      this.getCompraItems(false);

      // Refresh current item data to show updated tax amounts
      if (this.newItem.id) {
        this.refreshEditItemData();
      }
    },

    makeToast(variant = null, title = "", text = "") {
      if (variant == "success") {
        this.$bvToast.toast(text, {
          title: title,
          variant: variant,
          solid: true,
          appendToast: true,
        });
      } else {
        this.$bvModal.msgBoxOk(text, {
          title: title,
          okVariant: variant,
          centered: true
        })
      }
    },
  },
};
</script>
